import React from 'react';
import classnames from 'classnames';
const baseClassName = 'px-4 py-5 sm:px-6';
export default function PanelSection({ children, className, dataTestId }) {
    return (React.createElement("div", { "data-testid": dataTestId, className: classnames(baseClassName, className) }, children));
}
